import fetch from "@/uilts/request";

// 深圳风控报告
export default {
    /**
     * 创建授权书
     */
    createQr() {
        return fetch.post("UserReview/createQr")
    },
    checklist(data){
      return fetch.post("UserReview/checklist",data)
    },
    dsjcx(data){
      return fetch.post("UserReview/dsjcx",data)
    },
     dsjurl(data){
      return fetch.post("UserReview/dsjurl",data)
    },
     checkdel(data){
      return fetch.post("UserReview/checkdel",data)
    },
     zhiMiQuery(data){
      return fetch.post("UserReview/zhiMiQuery",data)
    },
     diTingQuery(data){
      return fetch.post("UserReview/diTingQuery",data)
    },

}